import { AIAssistantQuestionType, AICredits, AIAssistantConversationListData } from '@/types/ai-assistant'

import { AIAssistantMutationTypes } from './mutation_types'
import { AIAssistantState } from './state'

export const mutations = {
  [AIAssistantMutationTypes.SET_QUESTION_TYPE] (
    state: AIAssistantState,
    value: AIAssistantQuestionType | null,
  ) {
    state.questionType = value
  },
  [AIAssistantMutationTypes.SET_CONVERSATION_ACTIVE_ID] (state: AIAssistantState, value: string | null) {
    state.conversationActiveId = value
  },
  [AIAssistantMutationTypes.SET_CONVERSATIONS] (state: AIAssistantState, value: AIAssistantConversationListData) {
    state.conversations = value
  },
  [AIAssistantMutationTypes.SET_CONVERSATION_MESSAGES_PENDING] (state: AIAssistantState, value: boolean) {
    state.getConversationMessagesPending = value
  },
  [AIAssistantMutationTypes.SET_CONVERSATIONS_PENDING] (state: AIAssistantState, value: boolean) {
    state.getConversationsPending = value
  },
  [AIAssistantMutationTypes.SET_PANE_OPENED] (state: AIAssistantState, value: boolean) {
    state.isPaneOpened = value
  },
  [AIAssistantMutationTypes.SET_POST_PROMPT_PENDING] (state: AIAssistantState, value: boolean) {
    state.postPromptPending = value
  },
  [AIAssistantMutationTypes.SET_POST_PROMPT_STREAMING] (state: AIAssistantState, value: boolean) {
    state.postPromptStreaming = value
  },
  [AIAssistantMutationTypes.SET_POST_CONVERSATION_PENDING] (state: AIAssistantState, value: boolean) {
    state.postConversationPending = value
  },
  [AIAssistantMutationTypes.SET_CREDITS] (state: AIAssistantState, value: AICredits | null) {
    state.credits = value
  },
  [AIAssistantMutationTypes.SET_CREDITS_PENDING] (state: AIAssistantState, value: boolean) {
    state.creditsPending = value
  },
  [AIAssistantMutationTypes.SET_CREDITS_REMAINING] (state: AIAssistantState, value: number | null) {
    state.credits = { ...state.credits, remaining: value } as AICredits
  },
  [AIAssistantMutationTypes.SET_PENDING_CONVERSATION_ID] (state: AIAssistantState, value: string | null) {
    state.pendingConversationId = value
  },
}
